module.exports = __webpack_public_path__ + "static/media/header_placeholder.7e7ec38d.jpg";